export type Region = {
    id: number;
    name: string;
};

type PhotographerProducts = {
    drone: boolean;
    sketchUp: boolean;
    matterport: boolean;
    film: boolean;
};

type PhotographerWorkHours = {
    start: string;
    end: string;
    day: number;
    isAvailable: boolean;
    coordinates: string;
};

export type BookedEvent = {
    id: number;
    orderId: number;
    start: Date | null;
    end: Date | null;
    description: string;
    product: string;
    type: number;
    allDay: boolean;
    baseLocation: string;
    blockingLocation: string;
    coordinates: string;
    editable: boolean;
    isBackgroundEvent: boolean;
    isDusk: boolean;
    isExisting: boolean;
    photographerTimeZone: string;
    productNumberOfImages: number;
    site: number;
    spatialReferenceId: number;
    title: string;
    userId: number;
    userName: string;
};

export type Photographer = {
    id: number;
    name: string;
    profileImageReference: string;
    regionId: number;
    isAvailable: boolean;
    availableForProducts: PhotographerProducts;
    workingHours: PhotographerWorkHours[];
    phoneNumber?: string;
    email?: string;
    bookedEvents: BookedEvent[];
    travelDistance: number;
};

type OrderAddress = {
    address: string;
    city: string;
    regionId: string;
    addressPointLocation: { latitude: number; longitude: number };
};

type Customer = {
    agentId: number;
    brokerFirmId: number;
    brokerFirmName: string;
    agentName: string;
    commentFromAgent: string;
};

type OrderDeliveryProperties = {
    isEarlyDelivery: boolean;
    isExpress: boolean;
    isExpressWeekend: boolean;
};

type OrderListProperties = {
    isRead: boolean;
    isLocked: boolean;
    isLockedBy: {
        id: number;
        name: string | null;
    };
};

export type ProductProperties = {
    displayName: string;
    value: number;
};

export type PhotographerAvailableProductsTypes = {
    drone: boolean;
    measured: boolean;
    matterport: boolean;
    film: boolean;
};

export type OrderRow = {
    productId: number;
    numberOfImages: number | null;
    productOriginalName: string;
    productOverrideName: string | null;
    bookingCondition: number;
    deliveryTime: number;
    executionTime: number;
    isPhotographerProduct: number;
    isPossibleToSplitFromOrder: boolean;
    isStylingProduct: number;
    orderId: number;
    orderRowId: number;
    quantity: number;
    productType: number;
};

export type Order = {
    assignedUserId: number;
    assignedUserName: null | string;
    createdAt: string;
    customer: Customer;
    executionTime: number | null;
    internalComments: string;
    orderId: number;
    orderCollectionNumber: string;
    orderCollectionId: number;
    orderNumber: string;
    orderType: number;
    orderAddress: OrderAddress;
    orderDeliveryProperties: OrderDeliveryProperties;
    orderListProperties: OrderListProperties;
    orderRows: OrderRow[];
    packageProduct: string;
    preferredDate: string | null;
    preferredTimeSlot: string | null;
    productProperties: ProductProperties[];
    site: number;
    isHidden: boolean;
    keyPickupAddress?: string;
    keyPickupZip?: string;
    keyPickupCity?: string;
};

export enum ProductPropertiesTypes {
    Film = 19,
    Measured = 27,
    Matterport = 64,
    Drone = 65,
    KeyPickup = 72
}

export enum CommonProperties {
    drone = 65,
    measured = 27,
    matterport = 64,
    film = 19
}

export enum BookedEventType {
    available = 0,
    se360Booking = 1,
    scandphotosBooking = 2,
    blocked = 4,
    travel = 8
}

export enum DragItemType {
    Resize = 'resizer',
    Drag = 'drag-item'
}

export enum CalendarRowSize {
    small = '3.2rem',
    medium = '4.5rem',
    large = '7.2rem'
}

export enum CalendarItemSize {
    firstRowLarge = '6.5rem',
    medium = '4rem',
    large = '6.7rem'
}

export const productProperties = [
    {
        label: 'product-property/drone',
        value: 65
    },
    {
        label: 'product-property/film',
        value: 19
    },
    {
        label: 'product-property/measured',
        value: 27
    },
    {
        label: 'product-property/matterport',
        value: 64
    }
];
